// Simple session-scoped token store.
// Kept outside Zustand so both client.ts and gabAdmin.ts can import it
// without circular dependencies.

const KEY = 'oidc_access_token';
const USER_KEY = 'oidc_user';

export function storeToken(token: string | null): void {
  if (token) sessionStorage.setItem(KEY, token);
  else sessionStorage.removeItem(KEY);
}

export function getToken(): string | null {
  return sessionStorage.getItem(KEY);
}

export interface StoredUser {
  id: string;
  email: string;
  fullName: string;
  firstName: string;
  lastName: string;
  role: string;
  isAdmin: boolean;
}

export function storeOidcUser(user: StoredUser): void {
  sessionStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function loadOidcUser(): StoredUser | null {
  try {
    const s = sessionStorage.getItem(USER_KEY);
    return s ? JSON.parse(s) : null;
  } catch { return null; }
}

export function clearOidcSession(): void {
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem(USER_KEY);
}
